// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VouchersIndexRouteImport } from './routes/vouchers/index'
import { Route as TransactionHistoryIndexRouteImport } from './routes/transaction-history/index'
import { Route as RecurringOrdersIndexRouteImport } from './routes/recurring-orders/index'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsChangePasswordRouteImport } from './routes/settings/change-password'
import { Route as ProductsIntegrationRouteImport } from './routes/products/integration'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthCreatePasswordRouteImport } from './routes/auth/create-password'
import { Route as UsersSellersIndexRouteImport } from './routes/users/sellers/index'
import { Route as UsersSalesIndexRouteImport } from './routes/users/sales/index'
import { Route as UsersBuyersIndexRouteImport } from './routes/users/buyers/index'
import { Route as SettingsBankInformationIndexRouteImport } from './routes/settings/bank-information/index'
import { Route as ProductsListIndexRouteImport } from './routes/products/list/index'
import { Route as ProductsAutomationIndexRouteImport } from './routes/products/automation/index'
import { Route as DisbursementClaimOrdersIndexRouteImport } from './routes/disbursement/claim-orders/index'
import { Route as DisbursementClaimHistoryIndexRouteImport } from './routes/disbursement/claim-history/index'
import { Route as BillingTaxIndexRouteImport } from './routes/billing/tax/index'
import { Route as BillingReportIndexRouteImport } from './routes/billing/report/index'
import { Route as UsersSellersCreateRouteImport } from './routes/users/sellers/create'
import { Route as UsersSellersSellerIdRouteImport } from './routes/users/sellers/$sellerId'
import { Route as UsersSalesCreateRouteImport } from './routes/users/sales/create'
import { Route as UsersSalesSalesIdRouteImport } from './routes/users/sales/$salesId'
import { Route as SettingsBankInformationAddRouteImport } from './routes/settings/bank-information/add'
import { Route as SettingsBankInformationBankInfoIdRouteImport } from './routes/settings/bank-information/$bankInfoId'
import { Route as ProductsListPreviewRouteImport } from './routes/products/list/preview'
import { Route as ProductsListCreateRouteImport } from './routes/products/list/create'
import { Route as ProductsAutomationCreateRouteImport } from './routes/products/automation/create'
import { Route as ProductsListSlugReviewRouteImport } from './routes/products/list/$slug/review'
import { Route as ProductsListSlugEditRouteImport } from './routes/products/list/$slug/edit'
import { Route as ProductsAutomationSlugEditRouteImport } from './routes/products/automation/$slug/edit'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VouchersIndexRoute = VouchersIndexRouteImport.update({
  id: '/vouchers/',
  path: '/vouchers/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionHistoryIndexRoute = TransactionHistoryIndexRouteImport.update({
  id: '/transaction-history/',
  path: '/transaction-history/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecurringOrdersIndexRoute = RecurringOrdersIndexRouteImport.update({
  id: '/recurring-orders/',
  path: '/recurring-orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsChangePasswordRoute = SettingsChangePasswordRouteImport.update({
  id: '/settings/change-password',
  path: '/settings/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIntegrationRoute = ProductsIntegrationRouteImport.update({
  id: '/products/integration',
  path: '/products/integration',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCreatePasswordRoute = AuthCreatePasswordRouteImport.update({
  id: '/auth/create-password',
  path: '/auth/create-password',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersSellersIndexRoute = UsersSellersIndexRouteImport.update({
  id: '/users/sellers/',
  path: '/users/sellers/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersSalesIndexRoute = UsersSalesIndexRouteImport.update({
  id: '/users/sales/',
  path: '/users/sales/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersBuyersIndexRoute = UsersBuyersIndexRouteImport.update({
  id: '/users/buyers/',
  path: '/users/buyers/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBankInformationIndexRoute =
  SettingsBankInformationIndexRouteImport.update({
    id: '/settings/bank-information/',
    path: '/settings/bank-information/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductsListIndexRoute = ProductsListIndexRouteImport.update({
  id: '/products/list/',
  path: '/products/list/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsAutomationIndexRoute = ProductsAutomationIndexRouteImport.update({
  id: '/products/automation/',
  path: '/products/automation/',
  getParentRoute: () => rootRouteImport,
} as any)
const DisbursementClaimOrdersIndexRoute =
  DisbursementClaimOrdersIndexRouteImport.update({
    id: '/disbursement/claim-orders/',
    path: '/disbursement/claim-orders/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DisbursementClaimHistoryIndexRoute =
  DisbursementClaimHistoryIndexRouteImport.update({
    id: '/disbursement/claim-history/',
    path: '/disbursement/claim-history/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingTaxIndexRoute = BillingTaxIndexRouteImport.update({
  id: '/billing/tax/',
  path: '/billing/tax/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingReportIndexRoute = BillingReportIndexRouteImport.update({
  id: '/billing/report/',
  path: '/billing/report/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersSellersCreateRoute = UsersSellersCreateRouteImport.update({
  id: '/users/sellers/create',
  path: '/users/sellers/create',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersSellersSellerIdRoute = UsersSellersSellerIdRouteImport.update({
  id: '/users/sellers/$sellerId',
  path: '/users/sellers/$sellerId',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersSalesCreateRoute = UsersSalesCreateRouteImport.update({
  id: '/users/sales/create',
  path: '/users/sales/create',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersSalesSalesIdRoute = UsersSalesSalesIdRouteImport.update({
  id: '/users/sales/$salesId',
  path: '/users/sales/$salesId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBankInformationAddRoute =
  SettingsBankInformationAddRouteImport.update({
    id: '/settings/bank-information/add',
    path: '/settings/bank-information/add',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsBankInformationBankInfoIdRoute =
  SettingsBankInformationBankInfoIdRouteImport.update({
    id: '/settings/bank-information/$bankInfoId',
    path: '/settings/bank-information/$bankInfoId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductsListPreviewRoute = ProductsListPreviewRouteImport.update({
  id: '/products/list/preview',
  path: '/products/list/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsListCreateRoute = ProductsListCreateRouteImport.update({
  id: '/products/list/create',
  path: '/products/list/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsAutomationCreateRoute =
  ProductsAutomationCreateRouteImport.update({
    id: '/products/automation/create',
    path: '/products/automation/create',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductsListSlugReviewRoute = ProductsListSlugReviewRouteImport.update({
  id: '/products/list/$slug/review',
  path: '/products/list/$slug/review',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsListSlugEditRoute = ProductsListSlugEditRouteImport.update({
  id: '/products/list/$slug/edit',
  path: '/products/list/$slug/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsAutomationSlugEditRoute =
  ProductsAutomationSlugEditRouteImport.update({
    id: '/products/automation/$slug/edit',
    path: '/products/automation/$slug/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/products/integration': typeof ProductsIntegrationRoute
  '/settings/change-password': typeof SettingsChangePasswordRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/orders/': typeof OrdersIndexRoute
  '/recurring-orders/': typeof RecurringOrdersIndexRoute
  '/transaction-history/': typeof TransactionHistoryIndexRoute
  '/vouchers/': typeof VouchersIndexRoute
  '/products/automation/create': typeof ProductsAutomationCreateRoute
  '/products/list/create': typeof ProductsListCreateRoute
  '/products/list/preview': typeof ProductsListPreviewRoute
  '/settings/bank-information/$bankInfoId': typeof SettingsBankInformationBankInfoIdRoute
  '/settings/bank-information/add': typeof SettingsBankInformationAddRoute
  '/users/sales/$salesId': typeof UsersSalesSalesIdRoute
  '/users/sales/create': typeof UsersSalesCreateRoute
  '/users/sellers/$sellerId': typeof UsersSellersSellerIdRoute
  '/users/sellers/create': typeof UsersSellersCreateRoute
  '/billing/report/': typeof BillingReportIndexRoute
  '/billing/tax/': typeof BillingTaxIndexRoute
  '/disbursement/claim-history/': typeof DisbursementClaimHistoryIndexRoute
  '/disbursement/claim-orders/': typeof DisbursementClaimOrdersIndexRoute
  '/products/automation/': typeof ProductsAutomationIndexRoute
  '/products/list/': typeof ProductsListIndexRoute
  '/settings/bank-information/': typeof SettingsBankInformationIndexRoute
  '/users/buyers/': typeof UsersBuyersIndexRoute
  '/users/sales/': typeof UsersSalesIndexRoute
  '/users/sellers/': typeof UsersSellersIndexRoute
  '/products/automation/$slug/edit': typeof ProductsAutomationSlugEditRoute
  '/products/list/$slug/edit': typeof ProductsListSlugEditRoute
  '/products/list/$slug/review': typeof ProductsListSlugReviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/products/integration': typeof ProductsIntegrationRoute
  '/settings/change-password': typeof SettingsChangePasswordRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/orders': typeof OrdersIndexRoute
  '/recurring-orders': typeof RecurringOrdersIndexRoute
  '/transaction-history': typeof TransactionHistoryIndexRoute
  '/vouchers': typeof VouchersIndexRoute
  '/products/automation/create': typeof ProductsAutomationCreateRoute
  '/products/list/create': typeof ProductsListCreateRoute
  '/products/list/preview': typeof ProductsListPreviewRoute
  '/settings/bank-information/$bankInfoId': typeof SettingsBankInformationBankInfoIdRoute
  '/settings/bank-information/add': typeof SettingsBankInformationAddRoute
  '/users/sales/$salesId': typeof UsersSalesSalesIdRoute
  '/users/sales/create': typeof UsersSalesCreateRoute
  '/users/sellers/$sellerId': typeof UsersSellersSellerIdRoute
  '/users/sellers/create': typeof UsersSellersCreateRoute
  '/billing/report': typeof BillingReportIndexRoute
  '/billing/tax': typeof BillingTaxIndexRoute
  '/disbursement/claim-history': typeof DisbursementClaimHistoryIndexRoute
  '/disbursement/claim-orders': typeof DisbursementClaimOrdersIndexRoute
  '/products/automation': typeof ProductsAutomationIndexRoute
  '/products/list': typeof ProductsListIndexRoute
  '/settings/bank-information': typeof SettingsBankInformationIndexRoute
  '/users/buyers': typeof UsersBuyersIndexRoute
  '/users/sales': typeof UsersSalesIndexRoute
  '/users/sellers': typeof UsersSellersIndexRoute
  '/products/automation/$slug/edit': typeof ProductsAutomationSlugEditRoute
  '/products/list/$slug/edit': typeof ProductsListSlugEditRoute
  '/products/list/$slug/review': typeof ProductsListSlugReviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/products/integration': typeof ProductsIntegrationRoute
  '/settings/change-password': typeof SettingsChangePasswordRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/orders/': typeof OrdersIndexRoute
  '/recurring-orders/': typeof RecurringOrdersIndexRoute
  '/transaction-history/': typeof TransactionHistoryIndexRoute
  '/vouchers/': typeof VouchersIndexRoute
  '/products/automation/create': typeof ProductsAutomationCreateRoute
  '/products/list/create': typeof ProductsListCreateRoute
  '/products/list/preview': typeof ProductsListPreviewRoute
  '/settings/bank-information/$bankInfoId': typeof SettingsBankInformationBankInfoIdRoute
  '/settings/bank-information/add': typeof SettingsBankInformationAddRoute
  '/users/sales/$salesId': typeof UsersSalesSalesIdRoute
  '/users/sales/create': typeof UsersSalesCreateRoute
  '/users/sellers/$sellerId': typeof UsersSellersSellerIdRoute
  '/users/sellers/create': typeof UsersSellersCreateRoute
  '/billing/report/': typeof BillingReportIndexRoute
  '/billing/tax/': typeof BillingTaxIndexRoute
  '/disbursement/claim-history/': typeof DisbursementClaimHistoryIndexRoute
  '/disbursement/claim-orders/': typeof DisbursementClaimOrdersIndexRoute
  '/products/automation/': typeof ProductsAutomationIndexRoute
  '/products/list/': typeof ProductsListIndexRoute
  '/settings/bank-information/': typeof SettingsBankInformationIndexRoute
  '/users/buyers/': typeof UsersBuyersIndexRoute
  '/users/sales/': typeof UsersSalesIndexRoute
  '/users/sellers/': typeof UsersSellersIndexRoute
  '/products/automation/$slug/edit': typeof ProductsAutomationSlugEditRoute
  '/products/list/$slug/edit': typeof ProductsListSlugEditRoute
  '/products/list/$slug/review': typeof ProductsListSlugReviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/unauthorized'
    | '/auth/create-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verify'
    | '/products/integration'
    | '/settings/change-password'
    | '/settings/profile'
    | '/orders/'
    | '/recurring-orders/'
    | '/transaction-history/'
    | '/vouchers/'
    | '/products/automation/create'
    | '/products/list/create'
    | '/products/list/preview'
    | '/settings/bank-information/$bankInfoId'
    | '/settings/bank-information/add'
    | '/users/sales/$salesId'
    | '/users/sales/create'
    | '/users/sellers/$sellerId'
    | '/users/sellers/create'
    | '/billing/report/'
    | '/billing/tax/'
    | '/disbursement/claim-history/'
    | '/disbursement/claim-orders/'
    | '/products/automation/'
    | '/products/list/'
    | '/settings/bank-information/'
    | '/users/buyers/'
    | '/users/sales/'
    | '/users/sellers/'
    | '/products/automation/$slug/edit'
    | '/products/list/$slug/edit'
    | '/products/list/$slug/review'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/unauthorized'
    | '/auth/create-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verify'
    | '/products/integration'
    | '/settings/change-password'
    | '/settings/profile'
    | '/orders'
    | '/recurring-orders'
    | '/transaction-history'
    | '/vouchers'
    | '/products/automation/create'
    | '/products/list/create'
    | '/products/list/preview'
    | '/settings/bank-information/$bankInfoId'
    | '/settings/bank-information/add'
    | '/users/sales/$salesId'
    | '/users/sales/create'
    | '/users/sellers/$sellerId'
    | '/users/sellers/create'
    | '/billing/report'
    | '/billing/tax'
    | '/disbursement/claim-history'
    | '/disbursement/claim-orders'
    | '/products/automation'
    | '/products/list'
    | '/settings/bank-information'
    | '/users/buyers'
    | '/users/sales'
    | '/users/sellers'
    | '/products/automation/$slug/edit'
    | '/products/list/$slug/edit'
    | '/products/list/$slug/review'
  id:
    | '__root__'
    | '/'
    | '/unauthorized'
    | '/auth/create-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verify'
    | '/products/integration'
    | '/settings/change-password'
    | '/settings/profile'
    | '/orders/'
    | '/recurring-orders/'
    | '/transaction-history/'
    | '/vouchers/'
    | '/products/automation/create'
    | '/products/list/create'
    | '/products/list/preview'
    | '/settings/bank-information/$bankInfoId'
    | '/settings/bank-information/add'
    | '/users/sales/$salesId'
    | '/users/sales/create'
    | '/users/sellers/$sellerId'
    | '/users/sellers/create'
    | '/billing/report/'
    | '/billing/tax/'
    | '/disbursement/claim-history/'
    | '/disbursement/claim-orders/'
    | '/products/automation/'
    | '/products/list/'
    | '/settings/bank-information/'
    | '/users/buyers/'
    | '/users/sales/'
    | '/users/sellers/'
    | '/products/automation/$slug/edit'
    | '/products/list/$slug/edit'
    | '/products/list/$slug/review'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  AuthCreatePasswordRoute: typeof AuthCreatePasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  ProductsIntegrationRoute: typeof ProductsIntegrationRoute
  SettingsChangePasswordRoute: typeof SettingsChangePasswordRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  RecurringOrdersIndexRoute: typeof RecurringOrdersIndexRoute
  TransactionHistoryIndexRoute: typeof TransactionHistoryIndexRoute
  VouchersIndexRoute: typeof VouchersIndexRoute
  ProductsAutomationCreateRoute: typeof ProductsAutomationCreateRoute
  ProductsListCreateRoute: typeof ProductsListCreateRoute
  ProductsListPreviewRoute: typeof ProductsListPreviewRoute
  SettingsBankInformationBankInfoIdRoute: typeof SettingsBankInformationBankInfoIdRoute
  SettingsBankInformationAddRoute: typeof SettingsBankInformationAddRoute
  UsersSalesSalesIdRoute: typeof UsersSalesSalesIdRoute
  UsersSalesCreateRoute: typeof UsersSalesCreateRoute
  UsersSellersSellerIdRoute: typeof UsersSellersSellerIdRoute
  UsersSellersCreateRoute: typeof UsersSellersCreateRoute
  BillingReportIndexRoute: typeof BillingReportIndexRoute
  BillingTaxIndexRoute: typeof BillingTaxIndexRoute
  DisbursementClaimHistoryIndexRoute: typeof DisbursementClaimHistoryIndexRoute
  DisbursementClaimOrdersIndexRoute: typeof DisbursementClaimOrdersIndexRoute
  ProductsAutomationIndexRoute: typeof ProductsAutomationIndexRoute
  ProductsListIndexRoute: typeof ProductsListIndexRoute
  SettingsBankInformationIndexRoute: typeof SettingsBankInformationIndexRoute
  UsersBuyersIndexRoute: typeof UsersBuyersIndexRoute
  UsersSalesIndexRoute: typeof UsersSalesIndexRoute
  UsersSellersIndexRoute: typeof UsersSellersIndexRoute
  ProductsAutomationSlugEditRoute: typeof ProductsAutomationSlugEditRoute
  ProductsListSlugEditRoute: typeof ProductsListSlugEditRoute
  ProductsListSlugReviewRoute: typeof ProductsListSlugReviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vouchers/': {
      id: '/vouchers/'
      path: '/vouchers'
      fullPath: '/vouchers/'
      preLoaderRoute: typeof VouchersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-history/': {
      id: '/transaction-history/'
      path: '/transaction-history'
      fullPath: '/transaction-history/'
      preLoaderRoute: typeof TransactionHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recurring-orders/': {
      id: '/recurring-orders/'
      path: '/recurring-orders'
      fullPath: '/recurring-orders/'
      preLoaderRoute: typeof RecurringOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/change-password': {
      id: '/settings/change-password'
      path: '/settings/change-password'
      fullPath: '/settings/change-password'
      preLoaderRoute: typeof SettingsChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/integration': {
      id: '/products/integration'
      path: '/products/integration'
      fullPath: '/products/integration'
      preLoaderRoute: typeof ProductsIntegrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/create-password': {
      id: '/auth/create-password'
      path: '/auth/create-password'
      fullPath: '/auth/create-password'
      preLoaderRoute: typeof AuthCreatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/sellers/': {
      id: '/users/sellers/'
      path: '/users/sellers'
      fullPath: '/users/sellers/'
      preLoaderRoute: typeof UsersSellersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/sales/': {
      id: '/users/sales/'
      path: '/users/sales'
      fullPath: '/users/sales/'
      preLoaderRoute: typeof UsersSalesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/buyers/': {
      id: '/users/buyers/'
      path: '/users/buyers'
      fullPath: '/users/buyers/'
      preLoaderRoute: typeof UsersBuyersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/bank-information/': {
      id: '/settings/bank-information/'
      path: '/settings/bank-information'
      fullPath: '/settings/bank-information/'
      preLoaderRoute: typeof SettingsBankInformationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/list/': {
      id: '/products/list/'
      path: '/products/list'
      fullPath: '/products/list/'
      preLoaderRoute: typeof ProductsListIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/automation/': {
      id: '/products/automation/'
      path: '/products/automation'
      fullPath: '/products/automation/'
      preLoaderRoute: typeof ProductsAutomationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/disbursement/claim-orders/': {
      id: '/disbursement/claim-orders/'
      path: '/disbursement/claim-orders'
      fullPath: '/disbursement/claim-orders/'
      preLoaderRoute: typeof DisbursementClaimOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/disbursement/claim-history/': {
      id: '/disbursement/claim-history/'
      path: '/disbursement/claim-history'
      fullPath: '/disbursement/claim-history/'
      preLoaderRoute: typeof DisbursementClaimHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/tax/': {
      id: '/billing/tax/'
      path: '/billing/tax'
      fullPath: '/billing/tax/'
      preLoaderRoute: typeof BillingTaxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/report/': {
      id: '/billing/report/'
      path: '/billing/report'
      fullPath: '/billing/report/'
      preLoaderRoute: typeof BillingReportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/sellers/create': {
      id: '/users/sellers/create'
      path: '/users/sellers/create'
      fullPath: '/users/sellers/create'
      preLoaderRoute: typeof UsersSellersCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/sellers/$sellerId': {
      id: '/users/sellers/$sellerId'
      path: '/users/sellers/$sellerId'
      fullPath: '/users/sellers/$sellerId'
      preLoaderRoute: typeof UsersSellersSellerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/sales/create': {
      id: '/users/sales/create'
      path: '/users/sales/create'
      fullPath: '/users/sales/create'
      preLoaderRoute: typeof UsersSalesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/sales/$salesId': {
      id: '/users/sales/$salesId'
      path: '/users/sales/$salesId'
      fullPath: '/users/sales/$salesId'
      preLoaderRoute: typeof UsersSalesSalesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/bank-information/add': {
      id: '/settings/bank-information/add'
      path: '/settings/bank-information/add'
      fullPath: '/settings/bank-information/add'
      preLoaderRoute: typeof SettingsBankInformationAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/bank-information/$bankInfoId': {
      id: '/settings/bank-information/$bankInfoId'
      path: '/settings/bank-information/$bankInfoId'
      fullPath: '/settings/bank-information/$bankInfoId'
      preLoaderRoute: typeof SettingsBankInformationBankInfoIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/list/preview': {
      id: '/products/list/preview'
      path: '/products/list/preview'
      fullPath: '/products/list/preview'
      preLoaderRoute: typeof ProductsListPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/list/create': {
      id: '/products/list/create'
      path: '/products/list/create'
      fullPath: '/products/list/create'
      preLoaderRoute: typeof ProductsListCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/automation/create': {
      id: '/products/automation/create'
      path: '/products/automation/create'
      fullPath: '/products/automation/create'
      preLoaderRoute: typeof ProductsAutomationCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/list/$slug/review': {
      id: '/products/list/$slug/review'
      path: '/products/list/$slug/review'
      fullPath: '/products/list/$slug/review'
      preLoaderRoute: typeof ProductsListSlugReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/list/$slug/edit': {
      id: '/products/list/$slug/edit'
      path: '/products/list/$slug/edit'
      fullPath: '/products/list/$slug/edit'
      preLoaderRoute: typeof ProductsListSlugEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/automation/$slug/edit': {
      id: '/products/automation/$slug/edit'
      path: '/products/automation/$slug/edit'
      fullPath: '/products/automation/$slug/edit'
      preLoaderRoute: typeof ProductsAutomationSlugEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  AuthCreatePasswordRoute: AuthCreatePasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  ProductsIntegrationRoute: ProductsIntegrationRoute,
  SettingsChangePasswordRoute: SettingsChangePasswordRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  RecurringOrdersIndexRoute: RecurringOrdersIndexRoute,
  TransactionHistoryIndexRoute: TransactionHistoryIndexRoute,
  VouchersIndexRoute: VouchersIndexRoute,
  ProductsAutomationCreateRoute: ProductsAutomationCreateRoute,
  ProductsListCreateRoute: ProductsListCreateRoute,
  ProductsListPreviewRoute: ProductsListPreviewRoute,
  SettingsBankInformationBankInfoIdRoute:
    SettingsBankInformationBankInfoIdRoute,
  SettingsBankInformationAddRoute: SettingsBankInformationAddRoute,
  UsersSalesSalesIdRoute: UsersSalesSalesIdRoute,
  UsersSalesCreateRoute: UsersSalesCreateRoute,
  UsersSellersSellerIdRoute: UsersSellersSellerIdRoute,
  UsersSellersCreateRoute: UsersSellersCreateRoute,
  BillingReportIndexRoute: BillingReportIndexRoute,
  BillingTaxIndexRoute: BillingTaxIndexRoute,
  DisbursementClaimHistoryIndexRoute: DisbursementClaimHistoryIndexRoute,
  DisbursementClaimOrdersIndexRoute: DisbursementClaimOrdersIndexRoute,
  ProductsAutomationIndexRoute: ProductsAutomationIndexRoute,
  ProductsListIndexRoute: ProductsListIndexRoute,
  SettingsBankInformationIndexRoute: SettingsBankInformationIndexRoute,
  UsersBuyersIndexRoute: UsersBuyersIndexRoute,
  UsersSalesIndexRoute: UsersSalesIndexRoute,
  UsersSellersIndexRoute: UsersSellersIndexRoute,
  ProductsAutomationSlugEditRoute: ProductsAutomationSlugEditRoute,
  ProductsListSlugEditRoute: ProductsListSlugEditRoute,
  ProductsListSlugReviewRoute: ProductsListSlugReviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
